// import Image from "next/image";
import { cn } from '@/lib/utils';
import { ChatbotWidgetDesignSettings } from './index.type';
import DummyProfile from '@/assets/images/dummy_profile.png';

type ChatHeaderProps = {
  logoUrl: string;
  name: string;
  config: ChatbotWidgetDesignSettings;
};

export const ChatHeader = ({ name, config, logoUrl }: ChatHeaderProps) => {
  return (
    <div
      className="relative flex w-full items-center gap-4 px-6 py-4 shadow-lg"
      style={{
        background: `linear-gradient(to right, ${config.headerStartColor}, ${config.headerEndColor})`,
      }}
    >
      <img
        src={logoUrl || DummyProfile}
        alt="Alen Gouse"
        width={32}
        height={32}
        className="aspect-square rounded-sm object-contain"
      />
      <p
        className={cn('text-lg font-semibold text-high-emphasis')}
        style={{ color: config.titleColor }}
      >
        {name}
      </p>
    </div>
  );
};
